import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Card, CardActionArea } from '@material-ui/core';
import Text from 'Components/ComponentLibrary/Atoms/Text';

const styles = (theme) => ({
  root: {
    height: 104,
    width: '100%',
    boxShadow: 'unset',
    border: `2px solid ${theme.palette.facet.lightGray}`,
    borderRadius: theme.radius.md,
  },
  cardActionArea: {
    padding: theme.spacing(2),
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  img: {
    height: 50,
  },
  subtext: {
    color: theme.palette.facet.primaryGray,
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginTop: '4px',
  },
  primary: {
    color: theme.palette.facet.primaryBlue,
  },
});

const FinancialInstitutionCard = ({
  className,
  classes,
  logo,
  name,
  subText,
  onClick,
  test,
}) => {
  return (
    <Card
      className={classNames(className, classes.root)}
      data-test={test ? `institution-card-${test}` : 'institution-card'}
    >
      <CardActionArea
        onClick={onClick}
        disabled={!onClick}
        className={classes.cardActionArea}
      >
        {logo && <img className={classes.img} src={logo} alt={`${name}-logo`} />}
        {name && <Text variant={'h6'} weight={'bold'} noWrap text={name} />}
        {subText && <Text className={classes.subtext} text={subText} />}
      </CardActionArea>
    </Card>
  );
};

FinancialInstitutionCard.defaultProps = {
  className: '',
  logo: '',
  name: '',
  subText: '',
  onClick: undefined,
  test: null,
};

FinancialInstitutionCard.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  logo: PropTypes.string,
  name: PropTypes.string,
  subText: PropTypes.string,
  onClick: PropTypes.func,
  test: PropTypes.string,
};

export default withStyles(styles)(FinancialInstitutionCard);
